import { render, staticRenderFns } from "./ReplacementReport.vue?vue&type=template&id=ba237a96&"
import script from "./ReplacementReport.vue?vue&type=script&lang=js&"
export * from "./ReplacementReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports